import { ringDistance } from '../world/grid.js';
import { isInMeleeRange } from './combat.js';
/**
 * Whether nothing stands between two tiles: every tile the straight line
 * crosses, the ends excluded, lets a shot through. Bresenham's line, so the
 * answer is the same both ways and the same on every think.
 */
export function hasLineOfSight(from, to, open) {
    // Always walk from the lower end, so a→b and b→a cross the same tiles.
    if (from.y > to.y || (from.y === to.y && from.x > to.x))
        return hasLineOfSight(to, from, open);
    const dx = Math.abs(to.x - from.x);
    const dy = Math.abs(to.y - from.y);
    const sx = to.x > from.x ? 1 : -1;
    const sy = to.y > from.y ? 1 : -1;
    let x = from.x;
    let y = from.y;
    let error = dx - dy;
    for (;;) {
        if (x === to.x && y === to.y)
            return true;
        if ((x !== from.x || y !== from.y) && !open({ x, y }))
            return false;
        const twice = error * 2;
        if (twice > -dy) {
            error -= dy;
            x += sx;
        }
        if (twice < dx) {
            error += dx;
            y += sy;
        }
    }
}
/**
 * Whether a mob can strike `target` from where it stands: a neighbour for
 * everyone, and for a shooter any tile within its range in plain sight.
 */
export function canStrike(definition, from, target, open) {
    if (isInMeleeRange(from, target))
        return true;
    const ranged = definition.ranged;
    if (ranged === undefined)
        return false;
    return ringDistance(from, target) <= ranged.range && hasLineOfSight(from, target, open);
}
/** Whether this blow is a shot rather than a bite: a shooter out of melee. */
export function isShot(definition, from, target) {
    return definition.ranged !== undefined && !isInMeleeRange(from, target);
}
/** The shortest flight the eye can follow, even point-blank. */
export const MIN_FLIGHT_MS = 150;
/** How long a shot flies from one tile to another, straight, at the shooter's speed. */
export function flightMs(definition, from, to) {
    const speed = definition.ranged?.tilesPerSecond ?? 1;
    const distance = Math.hypot(to.x - from.x, to.y - from.y);
    return Math.max(MIN_FLIGHT_MS, Math.round((distance / speed) * 1000));
}
/**
 * The definition a blow is sized with: a shooter caught in melee hits with
 * its weaker `meleeDamage`, so standing next to it is the answer to it.
 */
export function blowOf(definition, shot) {
    if (shot || definition.ranged === undefined)
        return definition;
    return { ...definition, damage: definition.ranged.meleeDamage };
}
//# sourceMappingURL=ranged.js.map